import React from 'react'
import PropTypes from 'prop-types'
import * as UI from '../../../Common.styles'

const RemoveItemButton = ({
  removeFromCartActionHandler,
  service = false,
  ...props
}) =>
  <UI.Remove { ...props } bolder prevent to="/" handler={ () => { removeFromCartActionHandler(service) } }>
    Remove
  </UI.Remove>

RemoveItemButton.propTypes = {
  removeFromCartActionHandler: PropTypes.func,
  service: PropTypes.bool
}

export default RemoveItemButton
